import { FormlyFieldConfig } from 'ng-formly';
export const searchlayoutFields: Array<FormlyFieldConfig> = [
    {
        key: 'index',
        type: 'input-field',
        templateOptions: {
            type: 'number',
            required: true,
            label: 'Index'
        }
    },
    {
        key: 'name',
        type: 'input-field',
        templateOptions: {
            type: 'text',
            placeholder: 'Unique name for the search layout',
            required: true,
            label: 'Name'
        }
    },
    {
        key: 'label',
        type: 'input-field',
        templateOptions: {
            type: 'text',
            placeholder: 'Label for the search layout',
            required: true,
            label: 'Label'
        }
    },
    {
        key: 'description',
        type: 'textarea-field',
        templateOptions: {
            placeholder: '',
            required: true,
            label: 'Description'
        }
    },
    {
        key: 'fields',
        type: 'select-component',
        templateOptions: {
            type: 'entityfield',
            placeholder: '',
            required: true,
            multiple: true,
            label: 'Fields',
            description: 'Add the fields that should be shown for this search layout'
        }
    },
    {
        key: 'filter',
        type: 'textarea-field',
        templateOptions: {
            placeholder: '',
            required: true,
            label: 'Filter (Please Minify the JSON before Pasting here)',
            description: 'Add the json filter. See http://loopback.io/doc/en/lb3/Where-filter.html for more details'
        }
    },

    {
        key: 'defaultsort',
        type: 'select-component',
        templateOptions: {
            type: 'entityfield',
            placeholder: '',
            required: true,
            multiple: true,
            label: 'Default Sort',
            description: 'Choose one field even though it allows multipe'
        }
    },
    {
        key: 'defaultsorttype',
        type: 'select-component',
        templateOptions: {
            options: [{
                label: 'Ascending',
                value: 'asc'
            }, {
                label: 'Descending',
                value: 'desc'
            }],
            label: 'Sort Type',
            required: true,
            default: 'asc'
        }
    },

];


// WEBPACK FOOTER //
// ./src/app/shared/formfields/searchlayout.ts